function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5801 16.3895L6.5801 14.7995C7.0601 14.4195 7.3401 13.8395 7.3401 13.2295V10.6295C10.3601 9.64953 13.6301 9.63953 16.6601 10.6295V13.2395C16.6601 13.8495 16.9401 14.4295 17.4201 14.8095L19.4101 16.3895C20.2101 17.0195 21.3501 16.9595 22.0701 16.2395L23.2901 15.0195C24.0901 14.2195 24.0901 12.8895 23.2401 12.1395C16.8301 6.47953 7.1701 6.47953 0.760103 12.1395C-0.089897 12.8895 -0.089897 14.2195 0.710103 15.0195L1.9301 16.2395C2.6401 16.9595 3.7801 17.0195 4.5801 16.3895Z",
  fill: "#DE106B"
});

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f1c34995.svg";
export { ForwardRef as ReactComponent };